import { apiRequest } from '../../../api/client';
import type { AceGuidanceRequest, AceGuidanceResponse } from '../types/product-guidance';

export function askAceForGuidance(request: AceGuidanceRequest) {
  return apiRequest<AceGuidanceResponse>('/v1/ace/messages', {
    method: 'POST',
    body: JSON.stringify(request),
  });
}
